
	//门店名称 联系人 联系电话 公司地址 有效期 
	const columnList: Array<any> = [
		[
			{
				prop: "basicset_name",
				label: "名称",
				width: 200,
			},
			{
				prop: "basicset_order",
				label: "排序",
				width: 100,
			},
		],
		[
			{
				prop: "basicset_name",
				label: "名称",
				width: 200,
			},
			{
				prop: "basicset_order",
				label: "排序",
				width: 100,
			},
		],
		[
			{
				prop: "basicset_name",
				label: "名称",
				width: 200,
			},
			{
				prop: "basicset_order",
				label: "排序",
				width: 100,
			},
		]
	    
	];
	
	import {
		defineComponent,
		ref,
		reactive,
		inject,
		provide,
		onMounted,
		watch
	} from "vue";
	import { useRoute, useRouter } from 'vue-router'
	import { getframeworkList } from "@/api/http";
    import { storeUser } from "@/store/User";
	import {column} from "@/assets/types/common";
import axios from "axios";
import { Request } from "@/api/request";
	
	
	export default defineComponent({
	    name: "collection",
		setup() {
		        const setTitle: any = inject("setTitle");
		        setTitle(["支付方式"]);
		        let NavIndex = ref(0),
                    user = storeUser.getUser(),
		            tableData = ref([] as Array<any>),
		            loading = ref(true),
					headClass = inject("headClass"),
					dialog_model = ref(""),
					formRef = ref(null),
					form = ref({} as any),
					dialog_index = ref(0),
					Router = useRouter(),
					screenParameter = reactive({
                        page:1,
                        pagesize:10,
                        total:0
                    }),
				
		            getTableData = (): void => {
		                loading.value = true;
                        Request.axiosInstance({
                            url: 'adminapi/Basicset/list',
                            data: {
                                get_self:1,
                                basicset_type: (NavIndex.value == 0 ? 3 :
												NavIndex.value == 1 ? 4 :
												NavIndex.value == 2 ? 5 : 0),
                                ...screenParameter
                            }
                        }).then((res: any) => {
		                    tableData.value = res?.content?.list || [];
		                    loading.value = false;
		                    screenParameter.total = res?.content?.total;
		                });
		            },
					_option = (id: number, text: string) => {
						
					
						Router.push({
							path: '/framework/' + text,
							query: {
								id: id
							}
						})
					
					},
					_upState =(id: number, status: number) => {
						Request.axiosInstance({
							url:　'adminapi/Basicset/upState',
							data: {basicset_id: id, status: status, basicset_type: (NavIndex.value == 0 ? 3 :
												NavIndex.value == 1 ? 4 :
												NavIndex.value == 2 ? 5 : 0)}
						}).then((res: any) => {
		                    res.status == 202 && getTableData()
		                });
					},
                    _nav = (index: number) => {
                        NavIndex.value = index
                        getTableData()
                    },
                    handleSizeChange = (size:number)=>{
		                screenParameter.pagesize = size;
                        getTableData();
                    },
                    handleCurrentChange = (page:number)=>{
                        screenParameter.page = page;
                        getTableData();
                    },
					_submitForm = () => {
						(formRef.value as any).validate((valid: boolean) => {
                    		if (!valid) return
							Request.axiosInstance({
								url:  dialog_model.value == 'edit' ? 'adminapi/Basicset/edit' :  'adminapi/Basicset/create' ,
								data: form.value
							}).then((res: any) => {
								res.status == 202 && (getTableData(), dialog_model.value ='')
							})
						})
					}
			
					
					
		        onMounted(() => {
					
							
					var router = useRoute();
					console.log(router)
						
				
					
					getTableData()
		        });
				

				watch(dialog_model, (newval, oldval) => {
					if(newval == 'add')
					{
						form.value ={
							basicset_name: '',
							basicset_order: '',
							basicset_type: (NavIndex.value == 0 ? 3 :
											NavIndex.value == 1 ? 4 :
											NavIndex.value == 2 ? 5 : 0)
						}
					
					}
					else if(newval == 'edit')
					{
						form.value ={
							basicset_id: tableData.value[dialog_index.value].basicset_id,
							basicset_name: tableData.value[dialog_index.value].basicset_name,
							basicset_order: tableData.value[dialog_index.value].basicset_order,
							basicset_type: tableData.value[dialog_index.value].basicset_type,
						}
					}
				})
				
		        return {
		            columnList,
		            tableData,
		            loading,
					headClass,
					screenParameter,
					Router,
					_option,
                    NavIndex,
                    _nav,
					_upState,
					dialog_model,
					dialog_index,
					form,
					formRef,
					_submitForm,
                    handleSizeChange,
                    handleCurrentChange,
                    user
		        };
		    },
		});
		
